module.exports = __webpack_public_path__ + "static/media/capital.b53e9f2a.svg";